(function () {
  if (customElements.get('frostix-bonus-earning-preview')) return;

  var cartPresentation = {activeMember: false, earnedPoints: 0};
  var REQUEST_TIMEOUT_MILLISECONDS = 12_000;

  var previewRequests = new Map();
  var previewEpoch = 0;

  function previewObservationEvent(observation, event, value) {
    try { if (observation) observation[event](value); } catch (_observationError) {}
  }

  function invalidatePreviewCache(event) {
    var retained = new Set();
    if (event && event.type === 'frostix:bonus-club-preview-required' && event.detail && event.detail.ensureExactInFlight === true) {
      previewRequests.forEach(function (entry) {
        if (!entry.completedAt && ensureExactInFlight(event, null, entry)) retained.add(entry);
      });
    }
    if (retained.size) {
      previewRequests.forEach(function (entry, key) {
        if (!retained.has(entry)) { previewRequests.delete(key); entry.controller.abort(); }
      });
      return;
    }
    previewEpoch += 1;
    previewRequests.forEach(function (entry) { entry.controller.abort(); });
    previewRequests.clear();
  }
  document.addEventListener('frostix:bonus-club-membership-changed', invalidatePreviewCache);
  document.addEventListener('frostix:bonus-club-redemption-changed', invalidatePreviewCache);
  document.addEventListener('frostix:bonus-club-preview-required', invalidatePreviewCache);

  function readRequestTiming(body, outcome, status) {
    var manager = window.FrostixBonusClub;
    if (manager && typeof manager.readRequestTiming === 'function') {
      manager.readRequestTiming(body.cart_initial ? 'initial' : body.surface === 'cart' ? 'preview' : 'product_preview', outcome, status);
    }
  }

  function requestJson(url, body, signal, scope, initialOnly, cartRead) {
    var key = previewEpoch + '|' + String(scope || '') + '|' + url + '|' + JSON.stringify(body);
    var entry = previewRequests.get(key);
    if (entry && entry.completedAt && (initialOnly || Date.now() - entry.completedAt > 1_000)) {
      previewRequests.delete(key);
      entry = null;
    }
    if (!entry) {
      var controller = new AbortController();
      entry = {controller: controller, subscribers: new Set(), completedAt: 0,
        cartIdentity: !initialOnly && cartRead && cartRead.cartIdentity || null};
      var currentEntry = entry;
      var timeoutId;
      var observation = null;
      var observationFailure = null;
      var observationTimedOut = false;
      try {
        if (window.FrostixCartObservability && (body.surface === 'cart' || body.cart_initial === true)) {
          observation = window.FrostixCartObservability.startRequest(url, 'POST', 1);
        }
      } catch (_observationError) {}
      readRequestTiming(body, 'sent');
      entry.promise = Promise.race([
        fetch(url, {method: 'POST', credentials: 'same-origin',
          headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
          body: JSON.stringify(body), signal: controller.signal,
        }).then(async function (response) {
          previewObservationEvent(observation, 'response', response.status);
          readRequestTiming(body, 'response', response.status);
          var result = await response.json().catch(function () { return null; });
          if (observation) observationFailure = !response.ok ? 'http_error' : !result ? 'invalid_response' : null;
          if (controller.signal.aborted || !response.ok || !result) throw new Error('bonus_club_earning_preview_failed');
          return result;
        }),
        new Promise(function (_resolve, reject) {
          timeoutId = setTimeout(function () {
            observationTimedOut = true;
            controller.abort();
            reject(new Error('bonus_club_earning_preview_timeout'));
          }, REQUEST_TIMEOUT_MILLISECONDS);
        }),
      ]).then(function (result) {
        previewObservationEvent(observation, 'finish', 'ok');
        currentEntry.completedAt = Date.now();
        currentEntry.cartIdentity = null;
        if (initialOnly && previewRequests.get(key) === currentEntry) previewRequests.delete(key);
        return result;
      }, function (error) {
        previewObservationEvent(observation, 'finish', observationTimedOut ? 'timeout' : controller.signal.aborted ? 'aborted'
          : observationFailure || (error && error.name === 'TypeError' ? 'network_error' : 'other_error'));
        currentEntry.cartIdentity = null;
        readRequestTiming(body, 'failed', error && error.status);
        if (previewRequests.get(key) === currentEntry) previewRequests.delete(key);
        throw error;
      }).finally(function () { clearTimeout(timeoutId); });
      previewRequests.set(key, entry);
    }
    return new Promise(function (resolve, reject) {
      var subscriber = {cartRead: initialOnly ? null : cartRead};
      entry.subscribers.add(subscriber);
      var cleanup = function () {
        entry.subscribers.delete(subscriber);
        signal.removeEventListener('abort', cancel);
      };
      var cancel = function () {
        cleanup();
        reject(Object.assign(new Error('cancelled'), {name: 'AbortError'}));
        Promise.resolve().then(function () {
          if (entry.subscribers.size === 0 && !entry.completedAt) {
            entry.controller.abort();
            if (previewRequests.get(key) === entry) previewRequests.delete(key);
          }
        });
      };
      if (signal.aborted) { cancel(); return; }
      signal.addEventListener('abort', cancel, {once: true});
      entry.promise.then(function (result) { cleanup(); resolve(result); }, function (error) { cleanup(); reject(error); });
    });
  }

  function currentCartFingerprint(cart) {
    if (window.FrostixBonusClub && typeof window.FrostixBonusClub.fingerprint === 'function') {
      return window.FrostixBonusClub.fingerprint(cart);
    }
    return null;
  }

  function previewCartIdentity(cart) {
    if (!cart || typeof cart.token !== 'string' || !cart.token || !cartSnapshot(cart)) return null;
    try { return JSON.stringify(cart); } catch (_error) { return null; }
  }

  function cartBootstrapKey(source, cart) {
    var identity = previewCartIdentity(cart);
    if (!identity || !source.evidence || source.evidence.surface !== 'cart') return null;
    var evidence = Object.assign({}, source.evidence);
    delete evidence.cart_snapshot;
    var manager = window.FrostixBonusClub;
    return JSON.stringify([identity, source.dataset.customerScope,
      String(source.dataset.proxyBase || '').replace(/\/$/, ''), previewEpoch,
      manager && typeof manager.currentCustomerScope === 'function' ? manager.currentCustomerScope() : null, evidence]);
  }

  function currentCartRead(read, cart) {
    var manager = window.FrostixBonusClub;
    var source = read && read.source;
    var identity = previewCartIdentity(cart);
    if (!manager || typeof manager.currentCustomerScope !== 'function' || typeof manager.proxyBase !== 'function' ||
        !source || source.currentCartRead !== read || source.connected === false || read.signal.aborted ||
        read.epoch !== previewEpoch || !identity || identity !== read.cartIdentity ||
        !/^[1-9]\d*$/.test(String(read.scope)) || manager.currentCustomerScope() !== read.scope ||
        manager.sessionCustomerScope !== read.scope || source.dataset.customerScope !== read.scope ||
        manager.proxyBase() !== read.proxyBase || String(source.dataset.proxyBase || '').replace(/\/$/, '') !== read.proxyBase ||
        window.CartStore && window.CartStore.hasPending && window.CartStore.hasPending()) return false;
    var evidence = source.cartEvidence(cart);
    if (!evidence) return false;
    evidence = Object.assign({}, evidence);
    delete evidence.cart_snapshot;
    return read.evidenceKey === JSON.stringify(evidence);
  }

  function ensureExactInFlight(event, source, onlyEntry) {
    // Only this post-promo caller may retain a live read; ordinary forced events still invalidate it.
    var detail = event && event.detail;
    if (!event || event.type !== 'frostix:bonus-club-preview-required' || !detail || detail.ensureExactInFlight !== true) return false;
    var cart = window.CartStore && window.CartStore.getServerCart && window.CartStore.getServerCart();
    var identity = previewCartIdentity(cart);
    if (!identity || identity !== previewCartIdentity(detail.serverCart)) return false;
    for (var entry of onlyEntry ? [onlyEntry] : previewRequests.values()) {
      if (entry.completedAt || entry.controller.signal.aborted || entry.cartIdentity !== identity) continue;
      for (var subscriber of entry.subscribers) {
        var read = subscriber.cartRead;
        if ((!source || read && read.source === source) && currentCartRead(read, cart)) {
          read.ensured = true;
          return true;
        }
      }
    }
    return false;
  }

  function safeCents(value) {
    var number = Number(value);
    return Number.isSafeInteger(number) && number >= 0 ? number : null;
  }

  function lineSubtotalCandidates(item) {
    var finalLinePrice = safeCents(item && item.final_line_price);
    var lineLevelDiscount = safeCents(item && item.line_level_total_discount);
    if (finalLinePrice === null || lineLevelDiscount === null) return null;
    var allocated = (item.discount_allocations || []).reduce(function (total, allocation) {
      var amount = safeCents(allocation && allocation.amount);
      return amount === null || total === null ? null : total + amount;
    }, 0);
    if (allocated === null || !Number.isSafeInteger(allocated)) return null;
    var cartLevelAllocation = Math.max(0, allocated - lineLevelDiscount);
    if (cartLevelAllocation > finalLinePrice) return null;
    return {
      afterAllocations: finalLinePrice - cartLevelAllocation,
      finalLinePrice: finalLinePrice,
    };
  }

  function snapshotInteger(value) {
    return typeof value === 'number' && Number.isSafeInteger(value) && value >= 0 ? value : null;
  }

  function snapshotId(value) {
    return (typeof value === 'string' && /^\d+$/.test(value)) ||
      (typeof value === 'number' && Number.isSafeInteger(value) && value > 0)
      ? String(value) : null;
  }

  function snapshotDiscount(entry) {
    if (!entry || typeof entry !== 'object') return null;
    var application = entry.discount_application || entry;
    var amount = snapshotInteger(application.total_allocated_amount);
    if (amount === null || (entry.discount_application && snapshotInteger(entry.amount) !== amount)) return null;
    var fields = ['type', 'title', 'target_type', 'target_selection', 'value_type'];
    if (fields.some(function (field) {
      return typeof application[field] !== 'string' || !application[field];
    })) return null;
    var value = String(application.value == null ? '' : application.value);
    if (!/^\d+(?:\.\d+)?$/.test(value)) return null;
    value = value.replace(/^0+(?=\d)/, '').replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
    var title = application.title;
    if (application.type === 'discount_code' && /^[\x20-\x7e]+$/.test(title)) title = title.toUpperCase();
    return {
      key: typeof application.key === 'string' && application.key ? application.key : null,
      identity: JSON.stringify([application.type, title, application.target_type,
        application.target_selection, amount, application.value_type, value]),
      type: application.type,
    };
  }

  function cartSnapshot(cart) {
    if (!cart || typeof cart.currency !== 'string' || !/^[A-Z]{3}$/.test(cart.currency) ||
        snapshotInteger(cart.total_price) === null || !Array.isArray(cart.items) ||
        !Array.isArray(cart.cart_level_discount_applications)) return null;
    var keys = new Set();
    var items = [];
    for (var item of cart.items) {
      if (!item || typeof item.key !== 'string' || !item.key || keys.has(item.key)) return null;
      keys.add(item.key);
      var productId = snapshotId(item.product_id);
      var variantId = snapshotId(item.variant_id);
      var quantity = snapshotInteger(item.quantity);
      var prices = ['original_price', 'final_price', 'original_line_price', 'final_line_price',
        'line_level_total_discount'].map(function (field) { return snapshotInteger(item[field]); });
      if (!productId || !variantId || !quantity || prices.includes(null)) return null;
      var plan = item.selling_plan_allocation;
      var planId = plan == null ? null : snapshotId(plan.selling_plan && plan.selling_plan.id);
      if (plan != null && !planId) return null;
      items.push([item.key, productId, variantId, quantity].concat(prices, [planId]));
    }
    items.sort(function (left, right) { return left[0] < right[0] ? -1 : left[0] > right[0] ? 1 : 0; });
    var discounts = cart.cart_level_discount_applications.map(snapshotDiscount);
    if (discounts.includes(null)) return null;
    discounts.sort(function (left, right) {
      return left.identity < right.identity ? -1 : left.identity > right.identity ? 1 : 0;
    });
    if (discounts.some(function (discount, index) {
      return index > 0 && discount.identity === discounts[index - 1].identity;
    })) return null;
    return {currency: cart.currency, total: cart.total_price, items: items, discounts: discounts};
  }

  function renderedEvidenceMatchesCart(evidence, cart) {
    if (!evidence || evidence.surface !== 'cart' || !cartEvidenceIsReconciled(evidence)) return false;
    var rendered = cartSnapshot(evidence.cart_snapshot);
    var current = cartSnapshot(cart);
    if (!rendered || !current || evidence.currency_code !== current.currency ||
        evidence.cart_total_after_discounts_cents !== current.total || rendered.currency !== current.currency ||
        rendered.total !== current.total || JSON.stringify(rendered.items) !== JSON.stringify(current.items) ||
        rendered.discounts.length === 0 || rendered.discounts.length !== current.discounts.length ||
        evidence.lines.length !== evidence.cart_snapshot.items.length) return false;
    if (!evidence.lines.every(function (line, index) {
      var item = evidence.cart_snapshot.items[index];
      return snapshotId(line.product_id) === snapshotId(item.product_id) &&
        snapshotId(line.variant_id) === snapshotId(item.variant_id) &&
        snapshotInteger(line.subtotal_after_discounts_cents) !== null &&
        line.subtotal_after_discounts_cents <= item.final_line_price;
    })) return false;
    return rendered.discounts.every(function (discount, index) {
      var other = current.discounts[index];
      if (discount.identity !== other.identity) return false;
      if (discount.key && other.key && discount.key !== other.key) return false;
      return discount.type === 'discount_code' || Boolean(discount.key && other.key);
    });
  }

  function points(value) {
    return new Intl.NumberFormat(document.documentElement.lang || undefined).format(Number(value) || 0);
  }

  function formatCopy(template, value) {
    return String(template || '').replace('__POINTS__', points(value));
  }

  function applyCartPresentation(root) {
    root = root && typeof root.querySelector === 'function' ? root : document;
    var badge = root.querySelector('[data-bonus-earning-badge]');
    if (!badge) return;
    var value = badge.querySelector('[data-bonus-earning-badge-points]');
    if (value) value.textContent = points(cartPresentation.earnedPoints);
    badge.hidden = !cartPresentation.activeMember || cartPresentation.earnedPoints <= 0;
    badge.setAttribute(
      'aria-label',
      formatCopy(badge.dataset.labelTemplate, cartPresentation.earnedPoints)
    );
  }

  document.addEventListener('frostix:cart-drawer-patched', function () {
    applyCartPresentation(document);
  });

  function cartEvidenceIsReconciled(evidence) {
    if (!evidence || evidence.surface !== 'cart') return true;
    var cartTotal = safeCents(evidence.cart_total_after_discounts_cents);
    if (cartTotal === null || !Array.isArray(evidence.lines)) return false;
    if (evidence.lines.length === 0) return cartTotal === 0;
    var summedSubtotal = evidence.lines.reduce(function (total, line) {
      var subtotal = safeCents(line && line.subtotal_after_discounts_cents);
      return subtotal === null || total === null ? null : total + subtotal;
    }, 0);
    return summedSubtotal !== null && Number.isSafeInteger(summedSubtotal) && summedSubtotal === cartTotal;
  }

  customElements.define('frostix-bonus-earning-preview', class extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
      this.requestRevision = 0;
      this.initialCartReadAttempted = false;
      this.connectionRevision = 0;
      this.cartBootstrap = null;
      this.evidence = null;
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onCartChanged = this.onCartChanged.bind(this);
      this.onMembershipChanged = this.onMembershipChanged.bind(this);
      this.onRedemptionChanged = this.onRedemptionChanged.bind(this);
      this.onPreviewRequired = this.onPreviewRequired.bind(this);
    }

    connectedCallback() {
      this.connected = true;
      this.connectionRevision += 1;
      this.cartBootstrap = null;
      this.evidence = this.readEvidence();
      document.addEventListener('variant:change', this.onVariantChange);
      document.addEventListener('cart:changed', this.onCartChanged);
      document.addEventListener('frostix:bonus-club-membership-changed', this.onMembershipChanged);
      document.addEventListener('frostix:bonus-club-redemption-changed', this.onRedemptionChanged);
      document.addEventListener('frostix:bonus-club-preview-required', this.onPreviewRequired);
      if (this.evidence && this.evidence.surface === 'cart' && window.CartStore) {
        this.refreshFromAuthoritativeCart();
      } else {
        this.refresh();
      }
    }

    disconnectedCallback() {
      this.connected = false;
      this.connectionRevision += 1;
      this.cartBootstrap = null;
      document.removeEventListener('variant:change', this.onVariantChange);
      document.removeEventListener('cart:changed', this.onCartChanged);
      document.removeEventListener('frostix:bonus-club-membership-changed', this.onMembershipChanged);
      document.removeEventListener('frostix:bonus-club-redemption-changed', this.onRedemptionChanged);
      document.removeEventListener('frostix:bonus-club-preview-required', this.onPreviewRequired);
      this.invalidate();
    }

    readEvidence() {
      var script = this.querySelector('[data-bonus-earning-evidence]');
      if (!script) return null;
      try {
        var evidence = JSON.parse(script.textContent || 'null');
        return evidence && typeof evidence === 'object' ? evidence : null;
      } catch (_error) {
        return null;
      }
    }

    onVariantChange(event) {
      if (!this.evidence || this.evidence.surface !== 'product') return;
      var variant = event && event.detail && event.detail.variant;
      var line = this.evidence.lines && this.evidence.lines[0];
      var price = safeCents(variant && variant.price);
      if (!variant || !line || price === null) {
        this.hide();
        return;
      }
      line.variant_id = variant.id;
      line.subtotal_after_discounts_cents = price;
      this.refresh();
    }

    onCartChanged(event) {
      if (!this.evidence || this.evidence.surface !== 'cart') return;
      var detail = event && event.detail || {};
      if (!detail.flushed || !detail.serverCart) return;
      this.evidenceFingerprint = currentCartFingerprint(detail.serverCart);
      var nextEvidence = this.cartEvidence(detail.serverCart, detail.sections);
      if (!nextEvidence) {
        this.showUnavailable();
        return;
      }
      this.evidence = nextEvidence;
      if (this.cartBootstrap) this.cartBootstrap.handledKey = cartBootstrapKey(this, detail.serverCart);
      this.refresh();
    }

    refreshFromAuthoritativeCart() {
      var cartStore = window.CartStore;
      if (!cartStore || typeof cartStore.ready !== 'function') {
        this.showUnavailable();
        return;
      }
      var connection = this.connectionRevision;
      var bootstrap = this.cartBootstrap = {handledKey: null};
      var current = () => this.connected !== false && connection === this.connectionRevision && this.cartBootstrap === bootstrap;
      Promise.resolve(cartStore.ready())
        .then(() => {
          if (!current()) return null;
          var cart = typeof cartStore.getServerCart === 'function'
            ? cartStore.getServerCart()
            : null;
          if (cart) return cart;
          return typeof cartStore.refresh === 'function' ? cartStore.refresh() : null;
        })
        .then((cart) => {
          if (!current()) return;
          if (typeof cartStore.getServerCart === 'function') cart = cartStore.getServerCart();
          var handled = bootstrap.handledKey && bootstrap.handledKey === cartBootstrapKey(this, cart);
          if (handled) return;
          this.evidenceFingerprint = currentCartFingerprint(cart);
          var nextEvidence = this.cartEvidence(cart || {});
          if (!nextEvidence) {
            this.showUnavailable();
            return;
          }
          this.evidence = nextEvidence;
          this.refresh();
        })
        .catch(() => {
          if (!current()) return;
          this.showUnavailable();
        })
        .finally(() => {
          if (current()) this.cartBootstrap = null;
        });
    }

    onPreviewRequired(event) {
      if (!this.evidence || this.evidence.surface !== 'cart') return;
      if (ensureExactInFlight(event, this)) return;
      this.onCartChanged({detail: {flushed: true, serverCart: event.detail && event.detail.serverCart}});
    }

    invalidate() {
      this.requestRevision += 1;
      if (this.abortController) this.abortController.abort();
    }

    onMembershipChanged(event) {
      if (!event) invalidatePreviewCache();
      this.refresh();
    }

    onRedemptionChanged(event) {
      if (!this.evidence || this.evidence.surface !== 'cart') return;
      var detail = event && event.detail || {};
      var cart = detail.serverCart || detail.cart;
      this.evidenceFingerprint = currentCartFingerprint(cart);
      var nextEvidence = this.cartEvidence(cart || {});
      if (!nextEvidence) {
        this.hide();
        return;
      }
      this.evidence = nextEvidence;
      this.refresh();
    }

    updateCartPresentation(result, earnedPoints) {
      if (!this.evidence || this.evidence.surface !== 'cart') return;
      var drawer = null;
      if (typeof this.closest === 'function') {
        drawer = this.closest('cart-drawer');
      }
      drawer = drawer || document;
      cartPresentation = {
        activeMember: Boolean(result && result.presentation === 'earning'),
        earnedPoints: earnedPoints,
      };
      applyCartPresentation(drawer);
      if (typeof document.dispatchEvent === 'function') {
        var detail = {
          surface: 'cart',
          fingerprint: this.evidenceFingerprint || null,
          earnedPoints: earnedPoints,
          redemptionPreview: result && result.redemptionPreview || null,
          rule: result && result.rule || null,
        };
        if (detail.rule) {
          window.FrostixBonusClubEarningPreviewState = detail;
        }
        document.dispatchEvent(new CustomEvent('frostix:bonus-club-earning-preview', {detail: detail}));
      }
    }

    updateProductPresentation(earnedPoints) {
      if (!this.evidence || this.evidence.surface !== 'product') return;
      var badge = this.querySelector('[data-bonus-earning-product-badge]');
      if (!badge) return;
      var value = badge.querySelector('[data-bonus-earning-product-points]');
      if (value) value.textContent = points(earnedPoints);
      badge.hidden = earnedPoints <= 0;
      badge.setAttribute(
        'aria-label',
        formatCopy(badge.dataset.labelTemplate, earnedPoints)
      );
    }

    cartEvidence(cart, sections) {
      return this.ajaxCartEvidence(cart) || this.renderedCartEvidence(cart, sections);
    }

    renderedCartEvidence(cart, sections) {
      var evidence = this.readEvidence();
      if (renderedEvidenceMatchesCart(evidence, cart)) return evidence;
      sections = sections || cart.sections;
      var html = sections && sections['cart-drawer'];
      if (typeof html !== 'string' || typeof document.createElement !== 'function') return null;
      var template = document.createElement('template');
      template.innerHTML = html;
      for (var script of template.content.querySelectorAll('[data-bonus-earning-evidence]')) {
        try {
          evidence = JSON.parse(script.textContent || 'null');
          if (renderedEvidenceMatchesCart(evidence, cart)) return evidence;
        } catch (_error) {}
      }
      return null;
    }

    ajaxCartEvidence(cart) {
      var currentLines = this.evidence && this.evidence.lines || [];
      var metadata = new Map(currentLines.map(function (line) {
        return [String(line.variant_id), line];
      }));
      var candidates = [];
      var summedAfterAllocations = 0;
      var summedFinalLinePrices = 0;
      for (var item of cart.items || []) {
        var base = metadata.get(String(item.variant_id != null ? item.variant_id : item.id));
        var subtotalCandidates = lineSubtotalCandidates(item);
        if (!base || !subtotalCandidates) return null;
        summedAfterAllocations += subtotalCandidates.afterAllocations;
        summedFinalLinePrices += subtotalCandidates.finalLinePrice;
        if (!Number.isSafeInteger(summedAfterAllocations) ||
            !Number.isSafeInteger(summedFinalLinePrices)) return null;
        candidates.push({base: base, item: item, subtotals: subtotalCandidates});
      }
      var cartTotal = safeCents(cart.total_price);
      if (cartTotal === null) return null;
      if (candidates.length === 0) {
        return cartTotal === 0
          ? Object.assign({}, this.evidence, {
              cart_total_after_discounts_cents: 0,
              lines: [],
            })
          : null;
      }
      var subtotalKey = summedAfterAllocations === cartTotal
        ? 'afterAllocations'
        : summedFinalLinePrices === cartTotal
          ? 'finalLinePrice'
          : null;
      if (!subtotalKey) return null;
      var lines = candidates.map(function (candidate) {
        return Object.assign({}, candidate.base, {
          product_id: candidate.item.product_id,
          variant_id: candidate.item.variant_id != null
            ? candidate.item.variant_id
            : candidate.item.id,
          subtotal_after_discounts_cents: candidate.subtotals[subtotalKey],
        });
      });
      return Object.assign({}, this.evidence, {
        cart_total_after_discounts_cents: cartTotal,
        lines: lines,
      });
    }

    refresh() {
      var output = this.querySelector('[data-bonus-earning-output]');
      var proxyBase = String(this.dataset.proxyBase || '').replace(/\/$/, '');
      if (!output || !proxyBase || !this.evidence || !cartEvidenceIsReconciled(this.evidence)) {
        if (!this.initialCartReadAttempted && window.FrostixBonusClub && window.FrostixBonusClub.declineInitialPreview) {
          this.initialCartReadAttempted = true;
          window.FrostixBonusClub.declineInitialPreview(this);
        }
        this.hide();
        return;
      }
      var revision = ++this.requestRevision;
      var hideOutput = this.dataset.hideOutput === 'true';
      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();
      output.hidden = hideOutput;
      if (!hideOutput) output.textContent = this.dataset.copyLoading || '';
      this.updateCartPresentation(null, 0);
      this.updateProductPresentation(0);
      var requestEvidence = Object.assign({}, this.evidence);
      delete requestEvidence.cart_snapshot;
      var signal = this.abortController.signal;
      var scope = this.dataset.customerScope;
      var fingerprint = this.evidenceFingerprint;
      var epoch = previewEpoch;
      var evidenceKey = JSON.stringify(requestEvidence);
      var cart = window.CartStore && window.CartStore.getServerCart && window.CartStore.getServerCart();
      var cartKey = JSON.stringify(cartSnapshot(cart));
      var cartRead = this.currentCartRead = {source: this, signal: signal, scope: scope, proxyBase: proxyBase,
        epoch: epoch, evidenceKey: evidenceKey, cartIdentity: this.evidence.surface === 'cart' ? previewCartIdentity(cart) : null};
      var request = function (requestSignal, body, initialOnly) {
        return requestJson(proxyBase + '/earning-preview', body, requestSignal, scope, initialOnly, cartRead);
      };
      var initialRead = null;
      if (this.evidence.surface === 'cart') {
        var inFlightOnly = this.initialCartReadAttempted;
        this.initialCartReadAttempted = true;
        var manager = window.FrostixBonusClub;
        if (manager && typeof manager.initialPreviewRequest === 'function') {
          initialRead = manager.initialPreviewRequest(this, cart, requestEvidence, signal, request, inFlightOnly);
        }
      }
      (initialRead || request(signal, requestEvidence, false))
        .then((result) => {
          if (revision !== this.requestRevision) return;
          if (cartRead.ensured && !currentCartRead(cartRead, window.CartStore && window.CartStore.getServerCart && window.CartStore.getServerCart())) return;
          if (initialRead) {
            var currentCart = window.CartStore && window.CartStore.getServerCart && window.CartStore.getServerCart();
            var currentEvidence = this.cartEvidence(currentCart || {});
            if (currentEvidence) { currentEvidence = Object.assign({}, currentEvidence); delete currentEvidence.cart_snapshot; }
            if (this.connected === false || signal.aborted || scope !== this.dataset.customerScope || epoch !== previewEpoch ||
                fingerprint !== currentCartFingerprint(currentCart) || evidenceKey !== JSON.stringify(currentEvidence) ||
                cartKey !== JSON.stringify(cartSnapshot(currentCart)) ||
                window.CartStore && window.CartStore.hasPending && window.CartStore.hasPending()) return;
          }
          if (result && result.ok === true && ['ready', 'unavailable'].includes(result.status) &&
              this.evidence.surface === 'cart' && window.FrostixBonusClub && window.FrostixBonusClub.readTiming) {
            window.FrostixBonusClub.readTiming('preview_accepted');
          }
          if (!result.ok || result.status !== 'ready' || !result.award) {
            this.hide();
            return;
          }
          var earnedPoints = safeCents(result.award.earnedPointsSnapshot);
          if (earnedPoints === null) {
            this.hide();
            return;
          }
          output.hidden = hideOutput;
          var template = result.presentation === 'missed_benefit'
            ? this.dataset.copyMissed
            : this.dataset.copyReady;
          output.textContent = earnedPoints > 0
            ? formatCopy(template, earnedPoints)
            : this.dataset.copyZero || '';
          this.updateCartPresentation(result, earnedPoints);
          this.updateProductPresentation(earnedPoints);
        })
        .catch((error) => {
          if (error && error.name === 'AbortError') return;
          if (revision !== this.requestRevision) return;
          if (this.evidence && this.evidence.surface === 'cart') {
            this.showUnavailable();
            return;
          }
          this.hide();
        })
        .finally(() => {
          if (this.currentCartRead === cartRead) this.currentCartRead = null;
        });
    }

    hide() {
      this.invalidate();
      var output = this.querySelector('[data-bonus-earning-output]');
      if (output) output.hidden = true;
      this.updateCartPresentation(null, 0);
      this.updateProductPresentation(0);
    }

    showUnavailable() {
      this.invalidate();
      var output = this.querySelector('[data-bonus-earning-output]');
      var hideOutput = this.dataset.hideOutput === 'true';
      if (output) {
        output.hidden = hideOutput;
        if (!hideOutput) output.textContent = this.dataset.copyUnavailable || '';
      }
      this.updateCartPresentation(null, 0);
      document.dispatchEvent(new CustomEvent('frostix:bonus-club-earning-preview', {
        detail: {surface: 'cart', unavailable: true, fingerprint: this.evidenceFingerprint || null},
      }));
    }
  });
})();
